import { lazy } from 'react';
import { Navigate, useRoutes } from 'react-router-dom';
// layouts
// import DashboardLayout from './layouts/dashboard';
import SimpleLayout from './layouts/simple';
//
import BlogPage from './pages/BlogPage';
import UserPage from './pages/UserPage';
import LoginPage from './pages/LoginPage';
import Page404 from './pages/Page404';
import ProductsPage from './pages/ProductsPage';
import DashboardAppPage from './pages/DashboardAppPage';
import ResetPage from './pages/ResetPage';
import RoutesPage from './routes/RoutesPage';
import DriversPage from './drivers/DriversPage';
import VehiclesPage from './vehicles/VehiclesPage';
import EditRoutes from './routes/EditRoutes';
import Rides from './routes/Rides';
import CalendarView from './routes/CalendarView';
import RequirePrivilege from './auth/RequirePrivilege';
import { PRIVILEGE } from './auth/privileges';
import HomeRedirect from './auth/HomeRedirect';

const DashboardLayout = lazy(() => import('./layouts/dashboard'));

// const EventGroups = lazy(() => import('./event-groups/EventGroups'));
const Events = lazy(() => import('./events/Events'));
const NewEvent = lazy(() => import('./events/NewEvent'));
const ViewEvent = lazy(() => import('./events/ViewEvent'));

const ViewEventGroup = lazy(() => import('./events/ViewEventGroup'));

const UploadStockCSV = lazy(() => import('./events/UploadStockCSV'));

const Locations = lazy(() => import('./locations/Locations'));
const VouchersPage = lazy(() => import('./vouchers/VouchersPage'));
const OrganizersAdminPage = lazy(() => import('./admin/OrganizersAdminPage'));
const MerchantsAdminPage = lazy(() => import('./admin/MerchantsAdminPage'));
const FinancePage = lazy(() => import('./finance/FinancePage'));

// const NewEvent2 = lazy(() => import('./events/NewEvent'));

// const AddEventGroup = lazy(() => import('./event-groups/AddEventGroup'));

// const Buttons = lazy(() => import('../app_bkp/basic-ui/Buttons'));
// const Dropdowns = lazy(() => import('../app_bkp/basic-ui/Dropdowns'));

// const BasicElements = lazy(() => import('../app_bkp/form-elements/BasicElements'));

// const BasicTable = lazy(() => import('../app_bkp/tables/BasicTable'));

// const Mdi = lazy(() => import('../app_bkp/icons/Mdi'));

// const ChartJs = lazy(() => import('../app_bkp/charts/ChartJs'));

// const Error404 = lazy(() => import('../app_bkp/error-pages/Error404'));
// const Error500 = lazy(() => import('../app_bkp/error-pages/Error500'));

// const Login = lazy(() => import('./user-pages/Login'));
// const Register1 = lazy(() => import('../app_bkp/user-pages/Register'));

// const AddEvent = lazy(() => import('./event-groups/AddEvent'));
// const AddEventStations = lazy(() => import('./event-groups/AddEventStations'));
// const ViewEventTickets = lazy(() => import('./event-groups/ViewEventTickets'));
// const ViewEventStations = lazy(() => import('./event-groups/ViewEventStations'));

// ----------------------------------------------------------------------

export default function Router() {
  const guarded = (privilege, element) => <RequirePrivilege privilege={privilege}>{element}</RequirePrivilege>;

  const routes = useRoutes([
    {
      path: '/',
      element: <DashboardLayout />,
      children: [
        { element: <HomeRedirect />, index: true },
        { path: 'dashboard', element: <DashboardAppPage /> },
        { path: 'events-groups', element: guarded(PRIVILEGE.EVENTS, <Events />) },
        { path: 'events-groups/:id', element: guarded(PRIVILEGE.EVENTS, <ViewEventGroup />) },
        // { path: 'events-groups/:id/', element: <ViewEventGroup /> },
        { path: 'events', element: guarded(PRIVILEGE.EVENTS, <Events />) },
        { path: 'events/create', element: guarded(PRIVILEGE.EVENTS, <NewEvent />) },
        { path: 'events/:id/create', element: guarded(PRIVILEGE.EVENTS, <NewEvent />) },
        { path: 'events/:eventgroup', element: guarded(PRIVILEGE.EVENTS, <ViewEvent />) },
        { path: 'events/:eventgroup/:id', element: guarded(PRIVILEGE.EVENTS, <ViewEvent />) },
        { path: 'events/:eventgroup/:id/:tab', element: guarded(PRIVILEGE.EVENTS, <ViewEvent />) },
        { path: 'upload-stock/:event_id/:station_id/', element: guarded(PRIVILEGE.EVENTS, <UploadStockCSV />) },
        { path: 'users', element: guarded(PRIVILEGE.GLOBAL_ADMIN, <OrganizersAdminPage />) },
        { path: 'merchants', element: guarded(PRIVILEGE.GLOBAL_ADMIN, <MerchantsAdminPage />) },
        { path: 'finance', element: guarded(PRIVILEGE.FINANCE, <FinancePage />) },
        { path: 'locations', element: <Locations /> },
        { path: 'vouchers', element: guarded(PRIVILEGE.VOUCHERS, <VouchersPage />) },
        // Routes
        {
          path: 'routes',
          element: guarded(PRIVILEGE.RIDES, <RoutesPage />),
        },
        {
          path: 'routes/calendar/:routeId',
          element: guarded(PRIVILEGE.RIDES, <CalendarView />),
        },
        {
          path: 'routes/calendar',
          element: guarded(PRIVILEGE.RIDES, <CalendarView />),
        },
        { path: 'routes/:id', element: guarded(PRIVILEGE.RIDES, <EditRoutes />) },
        { path: 'rides/:routeId', element: guarded(PRIVILEGE.RIDES, <Rides />) },
        {
          path: 'drivers',
          element: guarded(PRIVILEGE.RIDES, <DriversPage />),
        },
        {
          path: 'vehicles',
          element: guarded(PRIVILEGE.RIDES, <VehiclesPage />),
        },
      ],
    },
    {
      path: 'login',
      element: <LoginPage />,
    },
    {
      path: 'reset-password',
      element: <ResetPage />,
    },
    {
      element: <SimpleLayout />,
      children: [
        { element: <Navigate to="/" />, index: true },
        { path: '404', element: <Page404 /> },
        { path: '*', element: <Navigate to="/404" /> },
      ],
    },
    {
      path: '*',
      element: <Navigate to="/404" replace />,
    },
  ]);

  return routes;
}
